/* ─────────────────────────────────────────────
   Idealball Party - Frontend enhancements
   - "cm" suffix su valori numerici di varianti dimensione
   - Pallini colorati su filtri colore
   - "Leggi di più" su descrizione collezione lunga
   - FBT live total + add-all-to-cart
   - Judge.me autoload helper
   ───────────────────────────────────────────── */
(function(){
  'use strict';

  /* ============ CM SUFFIX ============ */
  var DIM_KW = ['altezza','dimensione','misura','dimensioni','grandezza','size','height','larghezza'];
  var NUM_RE = /^\s*(\d+(?:[.,]\d+)?)\s*$/;
  var COLOR_KW = ['colore','color','colori','tinta'];

  function lc(s){ return (s||'').toString().toLowerCase().trim(); }
  function looksLike(arr, txt){ txt = lc(txt); return arr.some(function(k){ return txt.indexOf(k) !== -1; }); }

  function appendCm(el){
    var t = el.textContent;
    if (!t) return;
    var m = t.match(NUM_RE);
    if (m && t.indexOf('cm') === -1) {
      el.textContent = m[1] + ' cm';
    }
  }

  function patchPdpVariants(){
    document.querySelectorAll('.selector-wrapper, .product-form__item, .variant-wrapper, .single-option-radio').forEach(function(group){
      var labelEl = group.querySelector('.single-option-radio__legend, .form-field-label, .variant__label, legend');
      var groupName = labelEl ? labelEl.textContent : '';
      var dataName = group.querySelector('[data-option-name]');
      if (dataName) groupName += ' ' + (dataName.getAttribute('data-option-name') || '');
      if (!looksLike(DIM_KW, groupName)) return;
      group.querySelectorAll('.single-option-radio__label, .variant-input label').forEach(appendCm);
    });
  }

  function patchPlpFilters(){
    var allGroups = document.querySelectorAll('.filter-group, .filters-toolbar__group, .collection-sidebar__group, [class*="collection-sidebar__group--"]');
    allGroups.forEach(function(group){
      var heading = group.querySelector('.filter-group__display-heading, .filter-title, .filter-group__title, button, h3, h4, .toolbar__heading');
      var groupName = heading ? heading.textContent : '';
      var isDim = looksLike(DIM_KW, groupName);
      var isColor = looksLike(COLOR_KW, groupName);

      if (isDim) {
        // Append "cm" a tutti i testi numerici
        group.querySelectorAll('.filter__item-text, .filter-group__label, .filter__display-list label span, label span, .swatch__value').forEach(appendCm);
      }
      if (isColor) {
        group.classList.add('filter-group--color');
        // Per ogni label/voce, aggiungo un dot color inline + data-value
        group.querySelectorAll('label, .filter__display-list li').forEach(function(label){
          if (label.dataset.ibColored) return;
          label.dataset.ibColored = '1';
          var textEl = label.querySelector('span, .filter-group__label, .filter__item-text') || label;
          var val = lc(textEl.textContent);
          val = val.replace(/\(\d+\)/g,'').trim();
          label.setAttribute('data-value', val);

          // Mappa colore esplicita
          var colorMap = {
            ross: '#DC2626', red: '#DC2626',
            blu: '#2563EB', blue: '#2563EB', azzur: '#3B82F6',
            verd: '#16A34A', green: '#16A34A',
            giall: '#FACC15', yellow: '#FACC15',
            rosa: '#EC4899', pink: '#EC4899', fucsia: '#DB2777',
            arancion: '#F97316', orange: '#F97316',
            vio: '#9333EA', purple: '#9333EA', lilla: '#A855F7',
            ner: '#111827', black: '#111827',
            bianc: '#F9FAFB', white: '#F9FAFB',
            oro: '#D4AF37', gold: '#D4AF37',
            argent: '#9CA3AF', silver: '#9CA3AF', grig: '#6B7280', gray: '#6B7280',
            trasp: 'linear-gradient(135deg,#FFF,#E5E7EB)', clear: 'linear-gradient(135deg,#FFF,#E5E7EB)',
            multi: 'linear-gradient(45deg,#EF4444,#F59E0B,#10B981,#3B82F6,#8B5CF6)'
          };
          var dotColor = null;
          for (var key in colorMap) {
            if (val.indexOf(key) !== -1) { dotColor = colorMap[key]; break; }
          }
          if (dotColor) {
            label.style.setProperty('--ib-swatch-dot', dotColor);
          }
        });
      }
    });
  }

  /* ============ LEGGI DI PIÙ ============ */
  function setupReadMore(){
    var blocks = document.querySelectorAll('.template-collection .product-block--description, .template-collection .collection-description');
    blocks.forEach(function(block){
      if (block.dataset.ibReadMore) return;
      block.dataset.ibReadMore = '1';
      var fullHeight = block.scrollHeight;
      var lineHeight = parseFloat(getComputedStyle(block).lineHeight) || 24;
      if (fullHeight <= lineHeight * 4) return;

      block.classList.add('ib-desc--collapsed');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ib-desc__toggle';
      btn.textContent = 'Leggi di più ▾';
      btn.addEventListener('click', function(){
        var isCollapsed = block.classList.toggle('ib-desc--collapsed');
        btn.textContent = isCollapsed ? 'Leggi di più ▾' : 'Mostra meno ▴';
      });
      block.parentNode.insertBefore(btn, block.nextSibling);
    });
  }

  /* ============ FBT TOTAL CALCULATOR ============ */
  function setupFbt(){
    var form = document.querySelector('[data-fbt]');
    if (!form || form.dataset.ibInit) return;
    form.dataset.ibInit = '1';

    var totalEl = form.querySelector('[data-fbt-total]');
    var countEl = form.querySelector('[data-fbt-count]');
    var moneyFormat = (window.theme && window.theme.moneyFormat) || '{{amount}} €';

    function fmtMoney(cents){
      var v = (cents / 100).toFixed(2).replace('.', ',');
      return '€ ' + v;
    }

    function updateTotal(){
      var total = 0;
      var count = 1; // current product always counted
      // current price
      var curInput = form.querySelector('[name="ib-fbt-cur"]');
      if (curInput) total += parseInt(curInput.value, 10) || 0;
      // additional items
      form.querySelectorAll('[data-fbt-toggle]').forEach(function(cb){
        if (cb.checked) {
          total += parseInt(cb.value, 10) || 0;
          count += 1;
          // re-enable hidden input for cart
          var label = cb.closest('label');
          var hidden = label ? label.querySelector('[data-fbt-input]') : null;
          if (hidden) hidden.disabled = false;
        } else {
          var label = cb.closest('label');
          var hidden = label ? label.querySelector('[data-fbt-input]') : null;
          if (hidden) hidden.disabled = true;
        }
      });
      if (totalEl) totalEl.textContent = fmtMoney(total);
      if (countEl) countEl.textContent = count + (count === 1 ? ' articolo' : ' articoli');
    }

    form.querySelectorAll('[data-fbt-toggle]').forEach(function(cb){
      cb.addEventListener('change', updateTotal);
    });
    updateTotal();

    // Submit handler: add all to cart via Shopify cart API, then redirect
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var ids = [];
      form.querySelectorAll('input[name="items[][id]"]').forEach(function(input){
        if (!input.disabled) ids.push(input.value);
      });
      if (!ids.length) return;
      var btn = form.querySelector('.ib-btn-fbt');
      if (btn) { btn.disabled = true; btn.textContent = 'Aggiungo...'; }
      var items = ids.map(function(id){ return { id: parseInt(id, 10), quantity: 1 }; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r){ return r.json(); })
      .then(function(){ window.location.href = '/cart'; })
      .catch(function(err){
        console.error('FBT error', err);
        if (btn) { btn.disabled = false; btn.textContent = 'Aggiungi tutto al carrello'; }
        alert('Errore. Riprova.');
      });
    });
  }

  /* ============ BUY NOW (custom, no Shop Pay branded) ============ */
  function setupBuyNow(){
    document.querySelectorAll('[data-buy-now]').forEach(function(btn){
      if (btn.dataset.ibInit) return;
      btn.dataset.ibInit = '1';
      btn.addEventListener('click', function(){
        if (btn.disabled) return;
        var formId = btn.getAttribute('data-form-id');
        var form = formId ? document.getElementById(formId) : document.querySelector('form[action*="/cart/add"]');
        var variantId = btn.getAttribute('data-variant-id');
        var qty = 1;
        if (form) {
          var qtyInput = form.querySelector('input[name="quantity"]');
          if (qtyInput) qty = parseInt(qtyInput.value, 10) || 1;
          var idInput = form.querySelector('input[name="id"], select[name="id"]');
          if (idInput) variantId = idInput.value;
        }
        if (!variantId) return;

        btn.classList.add('is-loading');
        btn.textContent = 'Aggiungo...';

        // Add to cart, then redirect to checkout
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', qty);
        // Include line item properties from the form
        if (form) {
          form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach(function(p){
            if (p.value) fd.append(p.name, p.value);
          });
        }
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function(r){ return r.json(); })
          .then(function(){ window.location.href = '/checkout'; })
          .catch(function(){
            btn.classList.remove('is-loading');
            btn.textContent = 'Acquista subito';
            alert('Errore. Riprova.');
          });
      });
    });
  }

  /* ============ WISHLIST (localStorage, no app) ============ */
  var WISHLIST_KEY = 'ib_wishlist';
  // Toast di conferma riutilizzabile
  var _wishToast, _wishToastT;
  function wishToast(msg){
    if (!_wishToast) {
      _wishToast = document.createElement('div');
      _wishToast.className = 'ib-wish-toast';
      document.body.appendChild(_wishToast);
    }
    _wishToast.textContent = msg;
    _wishToast.classList.add('is-visible');
    clearTimeout(_wishToastT);
    _wishToastT = setTimeout(function(){ _wishToast.classList.remove('is-visible'); }, 1800);
  }
  function readWishlist(){
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch(e){ return []; }
  }
  function saveWishlist(arr){
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr)); } catch(e){}
  }
  // Aggiorna TUTTI i badge contatore wishlist (header desktop + mobile) e li nasconde se 0
  function updateWishlistCount(){
    var n = readWishlist().length;
    document.querySelectorAll('[data-wishlist-count], [data-ib-wish-count]').forEach(function(c){
      c.textContent = n;
      if (n > 0) { c.removeAttribute('hidden'); } else { c.setAttribute('hidden', ''); }
    });
  }
  function setupWishlist(){
    document.querySelectorAll('[data-wishlist]').forEach(function(btn){
      if (btn.dataset.ibInit) return;
      btn.dataset.ibInit = '1';
      // Uniformato su HANDLE (stesso identificatore dei cuori sulle card)
      var key = btn.getAttribute('data-product-handle') || btn.getAttribute('data-product-id');
      var label = btn.querySelector('[data-wishlist-label]');
      function refresh(){
        var list = readWishlist();
        var has = list.indexOf(key) !== -1;
        if (has) {
          btn.classList.add('is-active');
          if (label) label.textContent = '♥ Nei preferiti';
        } else {
          btn.classList.remove('is-active');
          if (label) label.textContent = 'Aggiungi ai preferiti';
        }
        updateWishlistCount();
      }
      btn.addEventListener('click', function(){
        var list = readWishlist();
        var i = list.indexOf(key);
        if (i === -1) { list.push(key); wishToast('Aggiunto ai preferiti ♥'); }
        else { list.splice(i, 1); wishToast('Rimosso dai preferiti'); }
        saveWishlist(list);
        refresh();
      });
      refresh();
    });
    updateWishlistCount();
  }

  /* ============ SUBCOLLECTIONS EXPAND (limita a 12 visibili via inline style + bottone toggle) ============ */
  function setupSubcollExpand() {
    document.querySelectorAll('[data-ib-subcoll-grid]').forEach(grid => {
      if (grid.dataset.ibInit) return;
      grid.dataset.ibInit = '1';
      const allItems = Array.from(grid.querySelectorAll('.ib-subcoll__item'));
      if (allItems.length <= 12) return;

      const hiddenItems = allItems.slice(12);
      // Nascondi via inline style (più robusto del CSS class)
      hiddenItems.forEach(item => { item.style.display = 'none'; });

      // Crea bottone toggle (sempre via JS)
      const wrap = document.createElement('div');
      wrap.className = 'ib-subcoll__expand-wrap';
      wrap.innerHTML = '<button type="button" class="ib-subcoll__expand" data-ib-subcoll-toggle>'
        + '<span data-ib-subcoll-label>Mostra tutte le ' + allItems.length + ' categorie</span>'
        + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>'
        + '</button>';
      grid.parentElement.appendChild(wrap);
      const btn = wrap.querySelector('button');
      const labelEl = btn.querySelector('[data-ib-subcoll-label]');
      let expanded = false;

      btn.addEventListener('click', () => {
        expanded = !expanded;
        hiddenItems.forEach(item => {
          item.style.display = expanded ? '' : 'none';
        });
        btn.classList.toggle('is-expanded', expanded);
        if (labelEl) {
          labelEl.textContent = expanded ? 'Mostra meno' : 'Mostra tutte le ' + allItems.length + ' categorie';
        }
      });
    });
  }

  /* ============ ENHANCE CARD PRODOTTO (wishlist + quick-add + save % + rating mini) ============ */
  function enhanceProductCards() {
    // Gira ovunque ci siano product cards (collection page, home featured-collection, search, ecc.)
    const cards = document.querySelectorAll('.grid-product, .grid__item--product');
    cards.forEach(card => {
      if (card.dataset.ibEnhanced) return;
      card.dataset.ibEnhanced = '1';

      // Trova le info utili dal markup esistente
      const link = card.querySelector('a[href*="/products/"]');
      const productHandle = link ? (link.getAttribute('href').match(/\/products\/([^?\/]+)/) || [])[1] : '';
      const productId = card.getAttribute('data-product-id') || '';
      const imageWrap = card.querySelector('.grid-product__image-wrapper, .grid-product__image-mask, .grid-product__media');
      if (!imageWrap || imageWrap.style.position === '') imageWrap.style.position = 'relative';

      // Save % calcolata da prezzo compare-at vs prezzo
      const priceEl = card.querySelector('.grid-product__price, .grid-product__price-wrap');
      const compareEl = card.querySelector('.grid-product__price--compare, .price--compare');
      if (compareEl && priceEl && imageWrap) {
        const compareTxt = (compareEl.textContent || '').replace(/[^\d,.]/g, '').replace(',', '.');
        const priceTxt = (priceEl.textContent || '').replace(compareEl.textContent || '', '').replace(/[^\d,.]/g, '').replace(',', '.');
        const compare = parseFloat(compareTxt);
        const price = parseFloat(priceTxt);
        if (compare > price && compare > 0) {
          const pct = Math.round((compare - price) / compare * 100);
          if (pct > 0 && !imageWrap.querySelector('.ib-card-save')) {
            const saveEl = document.createElement('span');
            saveEl.className = 'ib-card-save';
            saveEl.textContent = '−' + pct + '%';
            imageWrap.appendChild(saveEl);
          }
        }
      }

      // Wishlist heart icon
      if (imageWrap && !card.querySelector('.ib-card-wishlist') && productHandle) {
        const heart = document.createElement('button');
        heart.type = 'button';
        heart.className = 'ib-card-wishlist';
        heart.setAttribute('data-card-wishlist', '');
        heart.setAttribute('data-product-handle', productHandle);
        heart.setAttribute('aria-label', 'Aggiungi ai preferiti');
        heart.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z"/></svg>';
        imageWrap.appendChild(heart);
        try {
          const list = JSON.parse(localStorage.getItem('ib_wishlist') || '[]');
          if (list.indexOf(productHandle) !== -1) heart.classList.add('is-active');
        } catch(e){}
        heart.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          let list = [];
          try { list = JSON.parse(localStorage.getItem('ib_wishlist') || '[]'); } catch(e){}
          const idx = list.indexOf(productHandle);
          if (idx === -1) { list.push(productHandle); heart.classList.add('is-active'); wishToast('Aggiunto ai preferiti ♥'); }
          else { list.splice(idx, 1); heart.classList.remove('is-active'); wishToast('Rimosso dai preferiti'); }
          try { localStorage.setItem('ib_wishlist', JSON.stringify(list)); } catch(e){}
          updateWishlistCount();
        });
      }

      // Quick-add hover button (porta a PDP per ora)
      if (imageWrap && !card.querySelector('.ib-card-quickadd') && link) {
        const qa = document.createElement('a');
        qa.className = 'ib-card-quickadd';
        qa.href = link.getAttribute('href');
        qa.textContent = '+ Visualizza prodotto';
        imageWrap.appendChild(qa);
      }
    });
  }

  /* ============ RIMUOVI FILTRI DUPLICATI (drawer mobile + sidebar desktop entrambi visibili) ============ */
  function dedupeFilters() {
    if (!document.body.classList.contains('template-collection')) return;
    const allGroups = document.querySelectorAll('[class*="collection-sidebar__group--"]');
    if (allGroups.length < 2) return;
    const seen = {};
    allGroups.forEach(el => {
      const heading = el.querySelector('button, .filter-group__display-heading, .filter-group__title, h3, h4');
      const label = (heading?.textContent || '').toLowerCase().trim();
      if (!label) return;
      if (seen[label]) {
        // Tieni quello dentro la sidebar visibile, elimina l'altro
        const inSidebar = el.closest('.grid__item--sidebar, .collection-sidebar:not(.drawer)');
        const firstInSidebar = seen[label].closest('.grid__item--sidebar, .collection-sidebar:not(.drawer)');
        if (inSidebar && !firstInSidebar) {
          seen[label].remove();
          seen[label] = el;
        } else {
          el.remove();
        }
      } else {
        seen[label] = el;
      }
    });
  }

  /* ============ RIORDINA FILTRI COLLECTION (Tipo per primo, Disponibilità per ultimo) ============ */
  function reorderFilters() {
    if (!document.body.classList.contains('template-collection')) return;
    // Restringo a UN solo wrapper sidebar (non drawer), così non duplico
    const sidebar = document.querySelector('.grid__item--sidebar, .collection-sidebar:not(.drawer):not(.filter-drawer)');
    if (!sidebar) return;
    const groups = sidebar.querySelectorAll('[class*="collection-sidebar__group--"]');
    if (!groups.length) return;

    const items = Array.from(groups).map(el => {
      const heading = el.querySelector('.filter-group__display-heading, .filter-group__title, button, h3, h4');
      const label = (heading?.textContent || '').toLowerCase().trim();
      let priority = 5;
      if (/\btipo\b|categoria|prodotto|product type/.test(label)) priority = 1;
      else if (/tema|occasione|stagione/.test(label)) priority = 2;
      else if (/colore|color/.test(label)) priority = 3;
      else if (/dimension|altezza|misura|size/.test(label)) priority = 4;
      else if (/marca|brand|vendor/.test(label)) priority = 6;
      else if (/prezzo|price/.test(label)) priority = 7;
      else if (/disponib|stock|avail/.test(label)) priority = 9;
      return { el, priority, originalIdx: Array.prototype.indexOf.call(groups, el) };
    });
    items.sort((a, b) => {
      if (a.priority !== b.priority) return a.priority - b.priority;
      return a.originalIdx - b.originalIdx;
    });
    const parent = items[0].el.parentElement;
    items.forEach(item => parent.appendChild(item.el));
  }

  /* ============ STICKY TOP BAR PDP (appare quando ATC esce dalla viewport) ============ */
  function setupStickyTop(){
    const stickyBar = document.querySelector('[data-sticky-pdp]');
    if (!stickyBar) return;
    // ATC originale del buy box (Impulse)
    const atcBtn = document.querySelector('button[name="add"], .product-form__cart-submit, .add-to-cart');
    if (!atcBtn) return;

    // ATC della sticky bar replica il click dell'ATC originale
    const stickyAtc = stickyBar.querySelector('[data-sticky-atc]');
    if (stickyAtc) {
      stickyAtc.addEventListener('click', () => {
        atcBtn.click();
      });
    }

    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // Mostra sticky SOLO quando ATC è scrollato OLTRE in alto (top < 0).
          // Non quando ATC è ancora sotto la viewport iniziale (pagina appena caricata).
          var atcAboveViewport = entry.boundingClientRect.top < 0;
          if (!entry.isIntersecting && atcAboveViewport) {
            stickyBar.classList.add('is-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.classList.remove('is-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
      observer.observe(atcBtn);
    } else {
      // Fallback: scroll listener (mostra solo se ATC è sopra la viewport)
      window.addEventListener('scroll', () => {
        const rect = atcBtn.getBoundingClientRect();
        if (rect.bottom < 0) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    }
  }

  /* ============ AJAX ADD TO CART (toast invece di redirect a /cart) ============ */
  function setupAjaxAtc(){
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !form.matches) return;
      // Solo form add-to-cart PDP (action contiene /cart/add)
      var act = form.getAttribute('action') || '';
      if (!act.match(/\/cart\/add/i)) return;
      if (form.dataset.ibSkipAjax === 'true') return;

      // IMPORTANTE: blocca anche gli altri listener (Impulse theme.js fa redirect su cartType=page)
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var formData = new FormData(form);
      var atcBtn = form.querySelector('button[name="add"], .add-to-cart');
      var origText = atcBtn ? atcBtn.querySelector('[data-add-to-cart-text]') : null;
      var origLabel = origText ? origText.textContent : '';

      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.classList.add('is-adding');
        if (origText) origText.textContent = 'Aggiunto ✓';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      })
      .then(function(r){ return r.json(); })
      .then(function(data){
        if (data && data.status && data.status >= 400) {
          throw new Error(data.description || data.message || 'Errore');
        }
        ibUpdateCartBadge();
        ibShowToast('✓ Aggiunto al carrello');
        ibAnimateToCart(atcBtn);
        // Re-abilita bottone dopo breve delay
        setTimeout(function(){
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.classList.remove('is-adding');
            if (origText) origText.textContent = origLabel || 'Aggiungi al carrello';
          }
        }, 1200);
        // Notifica altri JS che il carrello è cambiato
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
      })
      .catch(function(err){
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.classList.remove('is-adding');
          if (origText) origText.textContent = origLabel || 'Aggiungi al carrello';
        }
        ibShowToast('⚠ ' + (err.message || 'Errore. Riprova.'));
      });
    }, true);
  }
  function ibUpdateCartBadge(){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var n = cart.item_count;
        // Tutti i possibili selettori dei badge (mobile, desktop, drawer)
        var badges = document.querySelectorAll(
          '.ib-mhead__cart-badge, .ib-header__cart-badge, ' +
          '[data-cart-count], .cart-link__bubble-num, ' +
          '.cart-count, .site-header__cart-count, ' +
          '.mh__cart-badge, .ib-mnav__cart-count'
        );
        badges.forEach(function(b){
          if (n > 0) {
            b.textContent = n;
            b.hidden = false;
            b.style.display = '';
            b.removeAttribute('hidden');
          } else {
            b.style.display = 'none';
            b.hidden = true;
          }
        });
        // Aggiorna anche il label "X art." e il prezzo totale nel desktop header
        document.querySelectorAll('.ib-header__action-label strong').forEach(function(el){
          // Formattazione approssimativa con virgola decimale italiana
          var price = (cart.total_price / 100).toFixed(2).replace('.', ',');
          el.textContent = '€' + price;
        });
        document.querySelectorAll('.ib-header__action-label span').forEach(function(el){
          el.textContent = n + ' art.';
        });
      })
      .catch(function(){});
  }
  function ibShowToast(message){
    var existing = document.querySelector('.ib-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'ib-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function(){ toast.classList.add('is-visible'); });
    setTimeout(function(){
      toast.classList.remove('is-visible');
      setTimeout(function(){ toast.remove(); }, 300);
    }, 2200);
  }
  function ibAnimateToCart(atcBtn){
    // Cerca l'icona del carrello (mobile header, desktop header, drawer)
    var cartIcon = document.querySelector(
      '.ib-mhead__cart, .ib-header__action--cart, ' +
      '.ib-mhead__cart-badge, .ib-header__cart-badge, ' +
      '[href="/cart"]'
    );
    if (!cartIcon) return;
    cartIcon.classList.add('ib-cart-bump');
    setTimeout(function(){ cartIcon.classList.remove('ib-cart-bump'); }, 600);
  }

  /* ============ QUANTITY SELECTOR ACCANTO AL ATC (mobile) ============ */
  function setupQuantityATCRow(){
    // Se il template Liquid renderizza già .ib-atc-row (server-side), non fare nulla
    if (document.querySelector('.ib-atc-row')) return;

    var attempts = 0;
    function tryMerge(){
      attempts++;
      var qty = document.querySelector('.product__quantity');
      var atcBtn = document.querySelector('button[name="add"], .add-to-cart');

      if (qty && atcBtn) {
        if (atcBtn.closest('.ib-atc-qty-row') || qty.closest('.ib-atc-qty-row')) return;

        var oldQtyBlock = qty.closest('.product-block') || qty.parentElement;

        var wrap = document.createElement('div');
        wrap.className = 'ib-atc-qty-row';
        atcBtn.parentNode.insertBefore(wrap, atcBtn);
        wrap.appendChild(qty);
        wrap.appendChild(atcBtn);

        // INLINE STYLE con setProperty + priority 'important' (massima specificità, batte ogni CSS esterno)
        var setIm = function(el, prop, val){ el.style.setProperty(prop, val, 'important'); };
        // wrap = flex row
        setIm(wrap, 'display', 'flex');
        setIm(wrap, 'flex-direction', 'row');
        setIm(wrap, 'flex-wrap', 'nowrap');
        setIm(wrap, 'align-items', 'stretch');
        setIm(wrap, 'gap', '10px');
        setIm(wrap, 'width', '100%');
        setIm(wrap, 'margin', '0 0 12px');
        // quantity = pillola fissa che non shrinka
        setIm(qty, 'flex', '0 0 auto');
        setIm(qty, 'width', 'auto');
        setIm(qty, 'max-width', 'none');
        setIm(qty, 'margin', '0');
        setIm(qty, 'padding', '0');
        setIm(qty, 'display', 'flex');
        setIm(qty, 'align-items', 'center');
        // ATC = riempie il resto
        setIm(atcBtn, 'flex', '1 1 0');
        setIm(atcBtn, 'min-width', '0');
        setIm(atcBtn, 'max-width', 'none');
        setIm(atcBtn, 'width', 'auto');
        setIm(atcBtn, 'margin', '0');
        setIm(atcBtn, 'display', 'block');

        if (oldQtyBlock && oldQtyBlock !== wrap && !oldQtyBlock.contains(wrap)) {
          oldQtyBlock.style.display = 'none';
        }
        return;
      }

      if (attempts < 15) setTimeout(tryMerge, 200);
    }
    tryMerge();
  }

  /* ============ REVIEW FORM TOGGLE (fallback se Judge.me non è attivo) ============ */
  function setupReviewForm(){
    const openBtns = document.querySelectorAll('[data-review-open]');
    const closeBtns = document.querySelectorAll('[data-review-close]');
    const form = document.querySelector('[data-review-form]');
    if (!form) return;
    openBtns.forEach(b => b.addEventListener('click', () => {
      form.hidden = false;
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const firstInput = form.querySelector('input[type="text"], input[type="email"]');
      if (firstInput) setTimeout(() => firstInput.focus(), 400);
    }));
    closeBtns.forEach(b => b.addEventListener('click', () => { form.hidden = true; }));
  }

  /* ============ JUDGE.ME LOADED HOOK ============
     Trigger: Judge.me popola .jdgm-rev-widg dentro al review widget,
     o aggiunge .jdgm-prev-badge__stars dentro al preview badge.
     Quando rilevato, marchiamo data-loaded e nascondiamo il fallback ricco.
     Se Judge.me non carica entro 5s, mostriamo il fallback (già visibile).
  */
  function watchJudgeMe(){
    var widget = document.querySelector('.jdgm-review-widget');
    var preview = document.querySelector('.jdgm-preview-badge');
    if (!widget && !preview) return;
    if (widget && widget.dataset.ibWatched) return;
    if (widget) widget.dataset.ibWatched = '1';

    function checkLoaded(){
      var loaded = false;
      if (widget) {
        if (widget.querySelector('.jdgm-rev-widg, .jdgm-rev-widg__title, .jdgm-rev-widg__reviews, .jdgm-rev-widg__summary')) {
          widget.setAttribute('data-loaded', 'true');
          loaded = true;
        }
      }
      if (preview) {
        if (preview.querySelector('.jdgm-prev-badge__stars, .jdgm-prev-badge')) {
          preview.setAttribute('data-loaded', 'true');
          // Hide my fallback rating row
          var rating = document.querySelector('.ib-pdp-rating__fallback');
          if (rating) rating.style.display = 'none';
          loaded = true;
        }
      }
      if (loaded) {
        // Hide rich fallback summary + cards
        var fb = document.querySelector('.ib-reviews-fallback');
        if (fb) fb.style.display = 'none';
      }
      return loaded;
    }

    if (checkLoaded()) return;
    var attempts = 0;
    var interval = setInterval(function(){
      attempts += 1;
      if (checkLoaded() || attempts > 30) clearInterval(interval);
    }, 1000);

    // Check tutto fatto dopo 5s anche per sicurezza
    setTimeout(checkLoaded, 5000);
  }

  /* ============ SEARCH EXACT PHRASE MATCH ============
     Intercetta il submit dei form search e wrappa la query in virgolette se ha
     più parole, così Shopify fa exact phrase match invece di OR sui token.
     Es: "peppa pig" → q="peppa pig" → trova solo prodotti con frase intera.
  */
  function setupSearchExactMatch(){
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !form.matches) return;
      var act = form.getAttribute('action') || '';
      // Solo form search (action contiene /search), non /cart/add
      if (!act.match(/\/search/i)) return;
      var input = form.querySelector('input[name="q"]');
      if (!input || !input.value) return;
      var v = input.value.trim();
      // Wrappa in virgolette se ci sono spazi e non è già wrappato
      if (v.indexOf(' ') !== -1 && v.charAt(0) !== '"') {
        input.value = '"' + v + '"';
      }
    }, true);
  }

  /* ============ RUN ============ */
  function runAll(){
    try { patchPdpVariants(); } catch(e){}
    try { patchPlpFilters(); } catch(e){}
    try { setupReadMore(); } catch(e){}
    try { setupFbt(); } catch(e){}
    try { setupBuyNow(); } catch(e){}
    try { setupWishlist(); } catch(e){}
    try { setupReviewForm(); } catch(e){}
    try { setupStickyTop(); } catch(e){}
    try { setupQuantityATCRow(); } catch(e){}
    try { setupAjaxAtc(); } catch(e){}
    try { setupSearchExactMatch(); } catch(e){}
    try { dedupeFilters(); } catch(e){}
    try { reorderFilters(); } catch(e){}
    try { enhanceProductCards(); } catch(e){}
    try { setupSubcollExpand(); } catch(e){}
    try { watchJudgeMe(); } catch(e){}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else { runAll(); }

  document.addEventListener('collection:updated', runAll);
  document.addEventListener('shopify:section:load', runAll);

  var grid = document.querySelector('[data-collection-products], .grid--collection, #CollectionAjaxResult');
  if (grid && 'MutationObserver' in window) {
    var mo = new MutationObserver(function(){ runAll(); });
    mo.observe(grid, { childList: true, subtree: true });
  }

})();
